import React from "react";
import { Result } from "antd";

function NotFound() {
  return <Result status="403" title="403" style={{ marginTop: "100px" }} />;
}

export default NotFound;
